import { PermissionCodename } from "constants/permission";
import { useSelector } from "react-redux";
import { RootState } from "reducers";

export default function usePermissions() {
  const userInfo = useSelector((state: RootState) => state.auth.userData);

  const permissions = userInfo?.user?.permissions || [];

  const hasPermissionTo = (permission: PermissionCodename) => {
    if (userInfo?.user?.is_superuser) return true; // superuser has all permissions
    return permissions.includes(permission);
  };

  return {
    permissions,
    hasPermissionTo,
    isSuperUser: userInfo?.user?.is_superuser,
  };
}
